// A primary action that leans a few pixels toward the pointer and springs home when it leaves
// (Osmo's magnetic buttons, kept small: --reach is 6px by default, never enough to chase).
// Motion values only, so the pointer never re-renders React; it follows on `bookObjectFollow`, the
// iOS spring for a thing under the finger. Off for touch and reduced motion.
import { m, useMotionValue, useReducedMotion, useSpring } from "motion/react";
import type { ReactNode } from "react";
import { MOTION } from "./tokens";
import s from "./motion.module.css";

export function Magnetic({ children, reach = 6, className }: { children: ReactNode; reach?: number; className?: string }) {
  const reduce = useReducedMotion();
  const x = useSpring(useMotionValue(0), MOTION.bookObjectFollow);
  const y = useSpring(useMotionValue(0), MOTION.bookObjectFollow);
  if (reduce) return <span className={[s.magnetic, className].filter(Boolean).join(" ")}>{children}</span>;
  return (
    <m.span
      className={[s.magnetic, className].filter(Boolean).join(" ")}
      style={{ x, y }}
      onPointerMove={(e) => {
        if (e.pointerType !== "mouse") return;
        const r = e.currentTarget.getBoundingClientRect();
        x.set(((e.clientX - r.left) / r.width - 0.5) * 2 * reach);
        y.set(((e.clientY - r.top) / r.height - 0.5) * 2 * reach);
      }}
      onPointerLeave={() => {
        x.set(0);
        y.set(0);
      }}
    >
      {children}
    </m.span>
  );
}
